<template>
    <BreadCrumb PageTitle="Détails sur une règle de tarification" />
    <ViewPricingRule/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import ViewPricingRule from "@/components/RegleTarification/ViewPricingRule.vue";
  
    export default defineComponent({
      name: "ViewBescPricingRulePage",
      components: {
        BreadCrumb,
        ViewPricingRule,
      },
    });
  </script>